import { render, staticRenderFns } from "./b14.vue?vue&type=template&id=17204dfa&scoped=true"
import script from "./b14.vue?vue&type=script&lang=js"
export * from "./b14.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17204dfa",
  null
  
)

export default component.exports